import { getLogger } from '../base/logging/functions';
/**
 * 深链接（Deep Linking）模块日志记录器.
 */
export default getLogger('features/deep-linking');
